/* Original artwork with the same subject-aware crop used in Ultimate metadata. */
(() => {
  if (customElements.get('matching-metal-card')) return;
  customElements.define('matching-metal-card', class extends HTMLElement {
    connectedCallback() {
      this.artwork = this.querySelector('[data-card-artwork]');
      this.placeholder = this.querySelector('[data-card-placeholder]');
      this.source = document.getElementById('design-image');
      if (!this.artwork || !this.source) return;
      this.revision = (this.revision || 0) + 1;
      this.artwork.onload = () => this.positionArtwork();
      this.artwork.onerror = () => this.showArtwork(false);
      // Preserve the editor's existing generated-preview save/drag protection.
      this.artwork.addEventListener('contextmenu', event => {
        if (typeof rpHasCleanTwin === 'function' && rpHasCleanTwin(this.source.src)) event.preventDefault();
      });
      this.observer = new MutationObserver(() => this.refresh());
      this.observer.observe(this.source, { attributes: true, attributeFilter: ['src', 'style', 'hidden'] });
      this.refresh();
    }
    showArtwork(ready) {
      this.artwork.hidden = !ready;
      this.placeholder.hidden = ready;
    }
    async positionArtwork() {
      const revision = this.revision, src = this.artwork.src;
      const layout = await window.RoboPixelSmartImage?.card(src, {width:this.artwork.naturalWidth, height:this.artwork.naturalHeight});
      if (!this.isConnected || revision !== this.revision || src !== this.artwork.src) return;
      this.artwork.style.objectPosition = layout ? `${layout.position.x}% ${layout.position.y}%` : '50% 50%';
      this.dataset.smartPlacement = 'ready';
      this.showArtwork(this.artwork.naturalWidth > 0);
    }
    refresh() {
      const src = this.source.getAttribute('src');
      if (!src || this.source.hidden || this.source.style.display === 'none') {
        ++this.revision;
        this.artwork.removeAttribute('src');
        this.showArtwork(false);
        return;
      }
      if (this.artwork.getAttribute('src') === src) return;
      ++this.revision;
      this.dataset.smartPlacement = 'pending';
      this.showArtwork(false);
      this.artwork.src = src;
    }
    disconnectedCallback() {
      ++this.revision;
      this.observer?.disconnect();
      if (this.artwork) this.artwork.onload = this.artwork.onerror = null;
    }
  });
})();
